import axios from "axios";
import * as html2canvas from "html2canvas";
import { toastr } from "react-redux-toastr";

import URL from "../config/api";

export const setObj = (typeId, objId, routeId) => (dispatch, getState) => {
  const state = getState();

  let route = routeId;
  if (!route) {
    const pathArray = window.location.pathname.split("/");
    const rawUrl = pathArray.filter(
      item =>
        typeof item !== "number" &&
        (typeof item !== "string" || !/^\d+(\.\d+)?$/.test(item))
    );
    const url = rawUrl.join("/");
    const selectedRoute = state.general.routes.find(item => item.url === url);

    route = selectedRoute?.id;
  }

  if (state.note.typeId === typeId && state.note.objId === objId) return;

  dispatch({ type: "SET_NOTES_INFO", payload: "Carregando..." });

  const actions = {
    insert: 5,
    update: 6,
    delete: 7,
    access: 8
  };

  const obj = {
    action_id: actions.access,
    link_id: route,
    type_id: typeId,
    obj1: objId,
    obj_id: objId,
    url: window.location.href,
    school_id: state.general.active_roles.school_id || null
  };

  axios
    .post(`${URL.api}audict/log/newInsert`, obj, {
      headers: { authorization: `Bearer ${state.user.token}` }
    })
    .then(resp => {
      dispatch({ type: "SET_NOTES_INFO", payload: resp.data.base });
    })
    .catch(() => {
      dispatch({
        type: "SET_NOTES_INFO",
        payload: "Não foi possível encontrar informações sobre a anotação"
      });
    });

  dispatch({ type: "SET_OBJ", payload: { typeId, objId } });
};

export const setNotes =
  (shouldSetLoading = true, obj) =>
  (dispatch, getState) => {
    const state = getState();

    if (shouldSetLoading) {
      dispatch({ type: "SET_NOTES_LOADING", payload: true });
    }

    if (obj?.helpdesk) {
      axios
        .get(
          `${URL.api}helpdesk/helpdesk/singleViewByLo/${obj.id_filho}`,
          // { type_id: state.note.typeId, obj_id: state.note.objId },
          { headers: { Authorization: `Bearer ${state.user.token}` } }
        )
        .then(
          resp => {
            dispatch({
              type: "SET_NOTES",
              payload: {
                note: resp.data.data,
                id_filho: obj?.id_filho,
                helpdesk: obj?.helpdesk
              }
            });
            dispatch({ type: "SET_NOTES_LOADING", payload: false });
          },
          error => {
            toastr.error("Erro!", "Não foi possível listar as anotações!");
            dispatch({ type: "SET_NOTES_LOADING", payload: false });
          }
        );
    } else {
      axios
        .post(
          `${URL.api}communication/note/list`,
          { type_id: state.note.typeId, obj_id: state.note.objId },
          { headers: { Authorization: `Bearer ${state.user.token}` } }
        )
        .then(
          resp => {
            dispatch({
              type: "SET_NOTES",
              payload: {
                note: resp.data.data,
                id_filho: obj?.id_filho,
                helpdesk: obj?.helpdesk
              }
            });
            dispatch({ type: "SET_NOTES_LOADING", payload: false });
          },
          error => {
            toastr.error("Erro!", "Não foi possível listar as anotações!");
            dispatch({ type: "SET_NOTES_LOADING", payload: false });
          }
        );
    }
  };

export const setAllNotes =
  (shouldSetLoading = true) =>
  (dispatch, getState) => {
    const state = getState();

    if (shouldSetLoading) {
      dispatch({ type: "SET_NOTES_LOADING", payload: true });
    }

    axios
      .post(`${URL.api}communication/note/list`, null, {
        headers: { Authorization: `Bearer ${state.user.token}` }
      })
      .then(
        resp => {
          dispatch({ type: "SET_NOTES", payload: resp.data.data });
          dispatch({ type: "SET_NOTES_LOADING", payload: false });
        },
        error => {
          toastr.error("Erro!", error.response.statusText);
          dispatch({ type: "SET_NOTES_LOADING", payload: false });
        }
      );
  };

export const setShowNotes = show => (dispatch, getState) => {
  dispatch({ type: "SET_SHOW_NOTES", payload: show });
};

export const setInterfaceNotes =
  (typeId, objId, shouldSetLoading = true) =>
  (dispatch, getState) => {
    const state = getState();

    if (shouldSetLoading) {
      dispatch({ type: "SET_INTERFACE_NOTES_LOADING", payload: true });
    }

    axios
      .post(
        `${URL.api}communication/note/list`,
        { type_id: typeId, obj_id: objId },
        { headers: { Authorization: `Bearer ${state.user.token}` } }
      )
      .then(
        resp => {
          dispatch({ type: "SET_INTERFACE_NOTES", payload: resp.data.data });
          dispatch({ type: "SET_INTERFACE_NOTES_LOADING", payload: false });
        },
        error => {
          toastr.error("Erro!", "Não foi possível listar as anotações!");
          dispatch({ type: "SET_INTERFACE_NOTES_LOADING", payload: false });
        }
      );
  };

export const setShowInterfaceNotes = show => (dispatch, getState) => {
  dispatch({ type: "SET_SHOW_INTERFACE_NOTES", payload: show });
};

export const showHelpdesk = (
  helpdeskTypeId = null,
  helpdeskObjId = null,
  helpdeskAddObjId = null
) => {
  const getDisplayMedia = options => {
    if (navigator.mediaDevices && navigator.mediaDevices.getDisplayMedia) {
      return navigator.mediaDevices.getDisplayMedia(options);
    }
    if (navigator.getDisplayMedia) {
      return navigator.getDisplayMedia(options);
    }
    if (navigator.webkitGetDisplayMedia) {
      return navigator.webkitGetDisplayMedia(options);
    }
    if (navigator.mozGetDisplayMedia) {
      return navigator.mozGetDisplayMedia(options);
    }

    throw new Error("getDisplayMedia is not defined");
  };

  const takeScreenshotStream = async () => {
    const width = window.screen.width * (window.devicePixelRatio || 1);
    const height = window.screen.height * (window.devicePixelRatio || 1);

    let stream;
    const mediaStreamConstraints = {
      audio: false,
      video: {
        width,
        height,
        frameRate: 1,
        displaySurface: "browser"
      }
    };

    stream = await getDisplayMedia(mediaStreamConstraints);

    return stream;
  };

  const takeScreenshotCanvas = async () => {
    const stream = await takeScreenshotStream();
    const video = document.createElement("video");
    const result = await new Promise((resolve, reject) => {
      video.onloadedmetadata = () => {
        video.play();
        video.pause();
        const canvas = document.createElement("canvas");
        canvas.width = video.videoWidth;
        canvas.height = video.videoHeight;
        const context = canvas.getContext("2d");
        context.drawImage(video, 0, 0, video.videoWidth, video.videoHeight);
        resolve(canvas);
      };
      video.srcObject = stream;
    });

    stream.getTracks().forEach(track => {
      track.stop();
    });

    if (result == null) {
      throw new Error("Cannot take canvas screenshot");
    }

    return result;
  };

  const screenshotTarget = document.body;

  return (dispatch, getState) => {
    takeScreenshotCanvas()
      .then(canvas => {
        const base64image = canvas.toDataURL("image/jpeg", 0.5);

        dispatch({
          type: "SET_SHOW_HELPDESK",
          payload: {
            base64image,
            helpdesk: true,
            helpdeskTypeId,
            helpdeskObjId,
            helpdeskAddObjId
          }
        });
      })
      .catch(err => {
        html2canvas(screenshotTarget).then(canvas => {
          const base64image = canvas.toDataURL("image/jpeg", 0.5);

          dispatch({
            type: "SET_SHOW_HELPDESK",
            payload: {
              base64image,
              helpdesk: true,
              helpdeskTypeId,
              helpdeskObjId,
              helpdeskAddObjId
            }
          });
        });
      });
  };
};

export const hideHelpdesk = () => (dispatch, getState) => {
  dispatch({
    type: "SET_SHOW_HELPDESK",
    payload: {
      base64image: null,
      helpdesk: false,
      helpdeskTypeId: null,
      helpdeskObjId: null,
      helpdeskAddObjId: null
    }
  });
};
